import React from "react";

import { copy } from "shared/assets";
import {
  Dimensions,
  FancyLink,
  hasDimensions,
  RTEContent,
} from "shared/components";
import { Spacer } from "shared/layout";
import { API_ENDPOINTS } from "shared/constants";
import { BoldText, MutedText } from "shared/styles";
import { formatNumber, getIdFromPath, Weight, WeightUnits } from "shared/utils";
import { useVenuePageContext } from "Venues/contexts";
import { VENUE_PATHS } from "Venues/router";

import { IEquipment } from "Venues/types";
import {
  getEquipmentMainCategory,
  getEquipmentSubCategory,
  useVenueRoute,
} from "Venues/utils";

const { equipmentProperties } = copy;

export const EquipmentDetail: React.FC<IEquipment> = ({
  stages,
  brand,
  category,
  model,
  weight,
  dimensions,
  remark,
  amount,
}) => {
  const { getPath } = useVenueRoute();
  const { venueStages } = useVenuePageContext();

  const getVenueStageTitle = (stageId: string) => {
    return venueStages.find(({ id }) => stageId.includes(id))?.title || "";
  };

  const renderRowItem = (
    title: string,
    body: string | undefined | JSX.Element
  ) => {
    if (body !== undefined && body !== null && body !== "") {
      return (
        <div>
          <BoldText>{title}</BoldText> <MutedText>{body}</MutedText>
        </div>
      );
    }
  };

  const renderDimensions = () =>
    hasDimensions(dimensions) && (
      <Spacer size="xxs" spaceDirection="horizontal">
        <BoldText>{equipmentProperties.dimensions.title}</BoldText>{" "}
        <MutedText>
          <Dimensions dimensions={dimensions} />
        </MutedText>
      </Spacer>
    );

  return (
    <Spacer size="xs">
      {renderRowItem(
        equipmentProperties.stages.short,
        <>
          {stages.map(({ id }, index) => (
            <span key={index}>
              {index !== 0 && ", "}
              <FancyLink
                to={getPath(VENUE_PATHS.STAGE, {
                  stageId: getIdFromPath(id, API_ENDPOINTS.STAGES),
                })}
              >
                {getVenueStageTitle(id)}
              </FancyLink>
            </span>
          ))}
        </>
      )}
      {renderRowItem(
        equipmentProperties.category.title,
        getEquipmentMainCategory(category)?.label
      )}
      {renderRowItem(
        equipmentProperties.subcategory.title,
        getEquipmentSubCategory(category)?.label
      )}
      {renderRowItem(equipmentProperties.brand.title, brand)}
      {renderRowItem(equipmentProperties.model.title, model)}
      {amount !== undefined &&
        renderRowItem(equipmentProperties.units.title, formatNumber(amount))}
      {renderDimensions()}
      {weight !== undefined &&
        renderRowItem(
          equipmentProperties.weight.title,
          new Weight(weight, WeightUnits.g).convert(WeightUnits.kg).toString()
        )}
      {remark &&
        renderRowItem(
          equipmentProperties.remark.title,
          <RTEContent content={remark} />
        )}
    </Spacer>
  );
};
